<div
  #container
  class="hedge__order__monitor__container"
  [nativeDesktopStyle]="{ '-webkit-app-region': 'no-drag' }"
>
  <bfx-splitter #splitter layout="vertical" [minSizesPx]="[120, 120]" [panelSizes]="data.initSizes">
    <!-- Top HOM panel in splitter -->
    <ng-template pTemplate>
      <div #topElement class="hedge__order__monitor__blotter__wrapper">
        <!-- TOP BAR - Filter -->
        <div class="bfx-view-tool-bar" #topMenu>
          <div class="blotter_titlebar_interaction">
            <div class="blotter_filter_bar_container">
              <!-- simple dropdown for algo filter types-->
              <bfx-algo-state-dropdown [(ngModel)]="stateFilter"></bfx-algo-state-dropdown>
              <div class="filter-bar-separator"></div>
              <div
                class="bfx-blotter-filter-bar blotter_filter_bar"
                [extendedTypeId]="extendedTypeId"
                [blotterInstance]="blotterInstance"
              ></div>
            </div>
            <div class="bfx-blotter-tools-container">
              <button
                type="button"
                [class]="data.showHideToggleClass"
                (click)="toggleStagingPanel()"
                title="Show/Hide staging area for new hedging orders"
              >
                <i [class]="iconClass"></i>
                <span>{{ data.stagingBtnLabel }}</span>
              </button>
              <div class="filter-bar-separator"></div>
              <bfx-quick-search
                class="bfx-quick-search"
                [(ngModel)]="searchValue"
                (ngModelChange)="onChangeSearchValue($event)"
              ></bfx-quick-search>
              <div class="blotter_titlebar_interaction_right">
                <bfx-icon-button
                  size="sm"
                  iconClass="icon_ion_filter_filled"
                  (action)="showFilterManager($event)"
                  title="Filter Manager"
                ></bfx-icon-button>
              </div>
            </div>
          </div>
        </div>

        <!-- Hedge Orders Blotter -->
        <bmark-hom-orders-blotter
          fxLayout="column"
          fxFlex="1 1 auto"
          #bmarkHedgeOrdersBlotter
          [parentComponent]="this"
          [doubleClickOpenOrderDetails]="true"
          [embeddedTableModeSuppressSelection]="false"
          [embeddedContextMenuService]="contextMenuService"
          [publishGridDataUpdateInfo]="true"
          [embeddedMode]="true"
          (gridReady)="onHedgeOrdersBlotterReady($event)"
          [stateFilter]="stateFilter"
        >
        </bmark-hom-orders-blotter>
      </div>
    </ng-template>

    <!-- Staging Area -->
    <!-- Bottom HOM panel in splitter -->
    <ng-template pTemplate>
      <div class="hedge__order__monitor__staging__area" [ngClass]="{ maximized: !data.show_panel }">
        <bfx-hedge-order-staging-panel
          #stagingPanel
          class="hom-staging-panel"
        ></bfx-hedge-order-staging-panel>
      </div>
    </ng-template>
  </bfx-splitter>
</div>
